import {useContext} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

export const BuyerStartingPaymentTransactionModal = () => {
  const {domain, i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const urlStaticsImages = domain.get('config').get('URL_STATICS_IMAGES')

  const imageUrl = `${urlStaticsImages}illustrations/coches-itv.svg`

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionBuyerStartingPaymentModal-modalContainer">
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionBuyerStartingPaymentModal-modalChildren">
                  <div className="mt-TransactionBuyerStartingPaymentModal-mainText">
                    {htmlStringToReactElement(
                      i18n.t('VEHICLE_TRANSACTION.STARTING_PAYMENT.MAIN_TEXT_1', {
                        highlightStart: '<strong>',
                        highlightEnd: '</strong>'
                      })
                    )}
                  </div>
                  <div className="mt-TransactionBuyerStartingPaymentModal-mainText">
                    {htmlStringToReactElement(
                      i18n.t('VEHICLE_TRANSACTION.STARTING_PAYMENT.MAIN_TEXT_2', {
                        highlightStart: '<strong><u>',
                        highlightEnd: '</u></strong>'
                      })
                    )}
                  </div>
                </div>
              ),
              headerImage: (
                <div className="mt-TransactionModal-contentHeaderImageWrapper">
                  <AtomImage
                    alt={i18n.t('VEHICLE_TRANSACTION.STARTING_PAYMENT.TITLE')}
                    className="mt-TransactionModal-contentHeaderImage"
                    src={imageUrl}
                  />
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.STARTING_PAYMENT.TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
